import axios from "axios";

const BASE_URL = "https://delivery-assurance.herokuapp.com/api/v1";
const request = axios.create({ baseURL: BASE_URL });
export const encode = (club) => Buffer.from(club).toString("base64");

// Gets all the projects for the current club
export const fetchProjects = (club) => {
  return request
    .get("/projects/", { headers: { Authorization: club } })
    .then(({ data }) => {
      return data.projects;
    });
};

// Create a project for the current club.
// Body must contain keys:
// projectName (str)
// clientName (str)
// startDate (dd-mm-yyyy)
// sdl (str)
// pdl (str)
// tdl (str)
export const createProject = (club, body) => {
  return request
    .post(`/projects`, body, { headers: { Authorization: club } })
    .then(({ data }) => {
      return data;
    });
};

// Gets all the project and instance details for a certain project.
export const fetchProjectByID = (club, projectID) => {
  return request
    .get(`/projects/${projectID}`, { headers: { Authorization: club } })
    .then(({ data }) => {
      return data.project;
    });
};

// Updates a project.
// body must contain keys:
// projectName (str)
// clientName (str)
// startDate (startDate)
// sdl (str)
// pdl (str)
// tdl (str)
export const updateProjectByID = (club, projectID, body) => {
  return request
    .put(`/projects/${projectID}`, body, { headers: { Authorization: club } })
    .then(({ data }) => {
      return data;
    });
};

// Gets all the instances for a project (would suggest to use fetchProjectByID, if you need both project + instance details)
export const fetchInstances = (club, projectID) => {
  return request
    .get(`/projects/${projectID}/instances`, {
      headers: { Authorization: club },
    })
    .then(({ data }) => {
      return data.instances;
    });
};

// Creates a new instance for the project and locks old instance (if avaliable).
// body must contain keys:
// highlights (array of strings)
// learnings (array of strings)
// people (object with 2 keys, score (int) and comments (array of strings))
// delivery (object with 2 keys, score (int) and comments (array of strings))
// commercialManagement (object with 2 keys, score (int) and comments (array of strings))
// techQuality (object with 2 keys, score (int) and comments (array of strings))
// clientManagement (object with 2 keys, score (int) and comments (array of strings))
// product (object with 2 keys, score (int) and comments (array of strings))
// actions (str)

// Gets the provided instance details.
export const fetchInstanceByID = (club, projectID, instanceID) => {
  return request
    .get(`/projects/${projectID}/instances/${instanceID}`, {
      headers: { Authorization: club },
    })
    .then(({ data }) => {
      // returns both the 'instance' and 'actions'
      return data;
    });
};

// Updates an instance.
// body must contain keys:
// highlights (array of strings)
// learnings (array of strings)
// people (object with 2 keys, score (int) and comments (array of strings))
// delivery (object with 2 keys, score (int) and comments (array of strings))
// commercialManagement (object with 2 keys, score (int) and comments (array of strings))
// techQuality (object with 2 keys, score (int) and comments (array of strings))
// clientManagement (object with 2 keys, score (int) and comments (array of strings))
// product (object with 2 keys, score (int) and comments (array of strings))
// actions (str)
export const updateInstanceByID = (club, projectID, instanceID, body) => {
  return request
    .put(`/projects/${projectID}/instances/${instanceID}`, body, {
      headers: { Authorization: club },
    })
    .then(({ data }) => {
      return data;
    });
};
export const createInstance = (club, projectID, body) => {
  return request
    .post(`/projects/${projectID}/instances`, body, {
      headers: { Authorization: club },
    })
    .then(({ data }) => {
      return data.success;
    });
};
